import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { IMAGES } from "@/data/site";

export const BrandShowcase = () => {
  return (
    <section data-testid="brand-showcase-section" className="bg-background pb-0">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl shadow-2xl"
        >
          <img
            src={IMAGES.brandTruck}
            alt="Templar Armor crew loading GAF Timberline shingles from a branded truck at a construction site"
            className="w-full h-[340px] sm:h-[460px] lg:h-[600px] object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/20 to-transparent" />

          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-700 px-2.5 py-1 text-[10px] sm:px-3.5 sm:py-1.5 sm:text-xs font-bold uppercase tracking-wide text-white">
              <ShieldCheck className="h-3.5 w-3.5 sm:h-4 sm:w-4" /> Real Templar Armor Crews
            </span>
            <h3 className="mt-4 font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-white max-w-2xl leading-tight text-balance">
              Our trucks. Our crews. Our craftsmanship.
            </h3>
            <p className="mt-2 text-slate-200 text-base sm:text-lg max-w-xl">
              A team that shows up ready to work, on every job across California.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
